import { Component, Input, AfterViewInit, OnInit } from '@angular/core';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { GoogleService } from '../../google/google.service';
import PlaceResult = google.maps.places.PlaceResult;


@Component({
  selector: 'app-places-info-window',
  templateUrl: './places-info-window.component.html',
  styleUrls: ['./places-info-window.component.scss']
})
export class PlacesInfoWindowComponent implements AfterViewInit, OnInit {
  @Input() activity: PlaceResult;
  activityDetailPromise: StatefulPromise<PlaceResult>;
  photoUrl: string = null;

  constructor(private _google: GoogleService) { }

  ngOnInit() {
  }

  async ngAfterViewInit() {
    await this._google.promise;
    await this.getActivityDetail();
  }

  async getActivityDetail() {
    this.activityDetailPromise = new StatefulPromise(this._google.placeDetails({
      placeId: this.activity.place_id,
      fields: ['name', 'rating', 'formatted_address', 'formatted_phone_number', 'photos', 'website', 'url']
    }));
    // sessionToken: new google.maps.places.AutocompleteSessionToken(),
    this.activityDetailPromise.promise.then((res) => {
      if (this.activityDetailPromise.value.photos && this.activityDetailPromise.value.photos.length > 0) {
        this.photoUrl = this.activityDetailPromise.value.photos[0].getUrl({'maxWidth': 100, 'maxHeight': 100});
      }
    });
  }

  get activityDetail(): PlaceResult {
    if (!this.activityDetailPromise || this.activityDetailPromise.state !== PromiseState.Fulfilled) {
      return null;
    }
    return this.activityDetailPromise.value;
  }
}
